import React from 'react'
import { Link } from 'gatsby'
import { Box, Heading, Button } from 'theme-ui'
import Section from '@components/Section'
import colors from '../../../@gatsby-theme-flexiblog/theme-ui/theme/color-preset'

/**
 * Shadow me to add your own content
 */

const styles = {
  heading: {
    mb: 4,
    span: {
      color: colors.gray[600]
    }
  },
  running: {
    color: `grayDark`,
    fontWeight: `body`,
    width: `5/6`
  }
}

export default () => (
  <>
    <Section>
      <Heading variant='h1' sx={styles.heading}>
        Start <span>Your Own</span> Line of Branded Skincare
      </Heading>
      <Heading variant='h3' sx={styles.running}>
        It's easier than you think with our turnkey private label program.
      </Heading>
    </Section>
    <Box variant='buttons.group' sx={styles.buttons}>
      <Button as={Link} to='/services/'>
        Services Offered
      </Button>
      <Button variant='white' as={Link} to='/private-label/'>
        View Products
      </Button>
    </Box>
  </>
)
